function onLoad() {
  const hash = `${+new Date()}${Math.random()}`;
  window.sessionStorage.setItem('tabHash', hash);
  const tabs = JSON.parse(localStorage.getItem('tabsOpened') || '{}');
  tabs[hash] = true;
  window.localStorage.setItem('tabsOpened', JSON.stringify(tabs));
}

function onUnload() {
  const hash = window.sessionStorage.getItem('tabHash');
  const tabs = JSON.parse(window.localStorage.getItem('tabsOpened') || '{}');
  if (hash) {
    tabs[hash] = undefined;
  }
  window.localStorage.setItem('tabsOpened', JSON.stringify(tabs));
}

export function tabs() {
  if (typeof window === 'undefined') {
    return;
  }
  onLoad();

  window.addEventListener('beforeunload', onUnload);
}
